export default __webpack_public_path__ + "static/production5r-c018c03aea895c9b0df9a190b528774d.jpg";